var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miniStats"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }